/* eslint-disable no-nested-ternary */
import { Avatar, Box, Card, CardContent, CardHeader, Divider, Grid, LinearProgress, Typography } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';
import SafetyDividerIcon from '@mui/icons-material/SafetyDivider';
import CampaignTime from './CampaignTime';
import CampaignCard from './CampaignCard';
import CampaignSource from './CampaignSource';
import CampaignTotal from './CampaignTotal';
import CampaignStatusList from './CampaignStatusList';
import { alpha } from '@mui/material/styles';
import { getTone } from '../../theme/tones';
import usePermissions from '../../hooks/usePermissions';

const CampaignStatsTab = (props) => {
  const { donnees, progressionProspects, setOpenReinjection, setOpenRetrieve, setSelectedCommercialReinjection, setSelectedCommercialRetrieve, idCampaign } = props;
  const theme = useTheme();
  const { user } = useAuth();
  const { can } = usePermissions();
  return (
    <>
      <Grid
        container
        justifyContent="space-between"
        spacing={2}
        sx={{ p: 1 }}
      >
        <Grid
          item
          md={6.5}
          xs={12}
        >
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
          >
            <Grid
              item
              md={6}
              xs={12}
              sx={{ pb: 2 }}
            >
              <Card
                sx={{ 
                  p: 3, 
                  height: 140,
                  borderRadius: '20px',
                  boxShadow: (theme) => `0 4px 18px 0 ${alpha(theme.palette.common.black, 0.03)}`,
                  border: '1px solid',
                  borderColor: 'divider'
                }}
              >
                <Box
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    height: '100%'
                  }}
                >
                  <Avatar
                    sx={{
                      backgroundColor: 'primary.main',
                      color: 'primary.contrastText',
                      width: 56,
                      height: 56,
                      borderRadius: '14px',
                      background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`
                    }}
                  >
                    <GroupsIcon
                      fontSize="medium"
                    />
                  </Avatar>
                  <Box sx={{ ml: 3 }}>
                    <Typography
                      color="textSecondary"
                      noWrap
                      variant="body2"
                      sx={{ fontWeight: 600, textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}
                    >
                      Nombre de prospects
                    </Typography>
                    <Typography
                      color="textPrimary"
                      sx={{ fontWeight: 800, mt: 0.5 }}
                      variant="h4"
                    >
                      {donnees.numberProspects !== undefined ? donnees.numberProspects.number : ''}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              {can('campaign.own_stats', user.id_service === 3) && (
              <Card
                sx={{
                  borderRadius: '20px',
                  boxShadow: (theme) => `0 4px 18px 0 ${alpha(theme.palette.common.black, 0.03)}`,
                  border: '1px solid',
                  borderColor: 'divider',
                  overflow: 'hidden'
                }}
              >
                <Typography
                  sx={{ p: 2, fontWeight: 700 }}
                  color="primary"
                  variant="subtitle1"
                >
                  Départements :
                  &nbsp;
                  <span style={{ color: theme.palette.text.primary }}>
                    {donnees.campaign !== undefined ? donnees.campaign.department : ''}
                  </span>
                </Typography>
                <Divider />
                <CardContent sx={{ p: 2.5 }}>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                    sx={{ lineHeight: 1.6 }}
                  >
                    {donnees.campaign !== undefined ? donnees.campaign.public : ''}
                  </Typography>
                </CardContent>
              </Card>
              )}
              {can('campaign.manage', user.access_level === 0) && (
              <Card
                sx={{ 
                  p: 3, 
                  height: 140,
                  borderRadius: '20px',
                  boxShadow: (theme) => `0 4px 18px 0 ${alpha(theme.palette.common.black, 0.03)}`,
                  border: '1px solid',
                  borderColor: 'divider'
                }}
              >
                <Box
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    height: '100%'
                  }}
                >
                  <Avatar
                    sx={{
                      backgroundColor: 'warning.main',
                      color: 'warning.contrastText',
                      width: 56,
                      height: 56,
                      borderRadius: '14px',
                      background: (theme) => `linear-gradient(135deg, ${theme.palette.warning.main} 0%, ${theme.palette.warning.main} 100%)`
                    }}
                  >
                    <SafetyDividerIcon
                      fontSize="medium"
                    />
                  </Avatar>
                  <Grid container sx={{ ml: 3 }} spacing={1}>
                    <Grid item xs={6}>
                      <Typography
                        color="textSecondary"
                        variant="caption"
                        sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', fontSize: '0.7rem', letterSpacing: '0.5px' }}
                      >
                        Non attribués
                      </Typography>
                      <Typography
                        color="textPrimary"
                        sx={{ fontWeight: 800, mt: 0.2 }}
                        variant="h5"
                      >
                        {donnees.numberProspectsNotAttributed !== undefined ? donnees.numberProspectsNotAttributed.number : ''}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        color="textSecondary"
                        variant="caption"
                        sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', fontSize: '0.7rem', letterSpacing: '0.5px' }}
                      >
                        Attribuables
                      </Typography>
                      <Typography
                        color="textPrimary"
                        sx={{ fontWeight: 800, mt: 0.2 }}
                        variant="h5"
                      >
                        {donnees.numberProspectsNotAttributed !== undefined ? donnees.numberProspectsNotAttributedAttribuable.number : ''}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Card>
              )}
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            sx={{ mt: 1 }}
          >
            <Grid
              item
              md={6}
              xs={12}
              sx={{ pb: 2 }}
            >
              <Card 
                sx={{ 
                  p: 2.5,
                  borderRadius: '20px',
                  boxShadow: (theme) => `0 4px 18px 0 ${alpha(theme.palette.common.black, 0.03)}`,
                  border: '1px solid',
                  borderColor: 'divider'
                }}
              >
                <CardHeader 
                  title="Progression de la campagne" 
                  titleTypographyProps={{ variant: 'subtitle1', sx: { fontWeight: 700 } }}
                  sx={{ p: 0, pb: 1.5 }}
                />
                <Divider sx={{ mx: -2.5, mb: 2 }} />
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                  <LinearProgress
                    value={progressionProspects}
                    variant="determinate"
                    sx={{
                      height: 10,
                      borderRadius: 5,
                      backgroundColor: 'action.hover',
                      '& .MuiLinearProgress-bar': {
                        borderRadius: 5,
                        background: (theme) => `linear-gradient(90deg, ${theme.palette.success.main} 0%, ${theme.palette.success.main} 100%)`
                      }
                    }}
                  />
                  <Box sx={{ mt: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography
                      color="textSecondary"
                      variant="body2"
                    >
                      Taux d'avancement
                    </Typography>
                    <Typography
                      color={getTone('emerald').base}
                      variant="subtitle2"
                      sx={{ fontWeight: 700, fontSize: '1.05rem' }}
                    >
                      {progressionProspects.toFixed(2)}%
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              {can('campaign.manage', user.access_level === 0) && (
              <Card
                sx={{
                  borderRadius: '20px',
                  boxShadow: (theme) => `0 4px 18px 0 ${alpha(theme.palette.common.black, 0.03)}`,
                  border: '1px solid',
                  borderColor: 'divider',
                  overflow: 'hidden'
                }}
              >
                <Typography
                  sx={{ p: 2, fontWeight: 700 }}
                  color="primary"
                  variant="subtitle1"
                >
                  Départements :
                  &nbsp;
                  <span style={{ color: theme.palette.text.primary }}>
                    {donnees.campaign !== undefined ? donnees.campaign.department : ''}
                  </span>
                </Typography>
                <Divider />
                <CardContent sx={{ p: 2.5 }}>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                    sx={{ lineHeight: 1.6 }}
                  >
                    {donnees.campaign !== undefined ? donnees.campaign.public : ''}
                  </Typography>
                </CardContent>
              </Card>
              )}
            </Grid>
          </Grid>
        </Grid>
        {can('campaign.manage', user.access_level === 0) && (
        <Grid
          sx={{
            backgroundColor: 'background.default',
          }}
          item
          md={5.5}
          xs={12}
        >
          <CampaignTime
            timeToPass={donnees.timeToPass !== undefined ? donnees.timeToPass.time : ''}
            averageTime={donnees.timeToPass !== undefined && donnees.totalTreatedReinjOrNotCustomers !== undefined ? donnees.timeToPass.time / donnees.totalTreatedReinjOrNotCustomers.number : ''}
          />
        </Grid>
        )}
        {can('campaign.manage', user.access_level === 0) && (
        <Grid
          sx={{
            backgroundColor: 'background.default',
            p: 1.5,
          }}
        >
          <CampaignCard
            infoCommercial={donnees.infoCommercial}
            commercial={donnees.commercial}
            setOpenReinjection={setOpenReinjection}
            setOpenRetrieve={setOpenRetrieve}
            setSelectedCommercialReinjection={setSelectedCommercialReinjection}
            setSelectedCommercialRetrieve={setSelectedCommercialRetrieve}
            idCampaign={idCampaign}
            numberProspectsAttribuable={donnees.numberProspectsNotAttributedAttribuable === undefined ? 0 : donnees.numberProspectsNotAttributedAttribuable.number}
          />
        </Grid>
        )}
      </Grid>
      {/* {user.id_service === 3 && typeCampaign === 'réinjection' && (
      <Grid
        sx={{
          backgroundColor: 'background.default', p: 1
        }}
      >
        <CampaignStatusReinjection campaignId={idCampaign} />

      </Grid>
      )} */}
      {!can('campaign.manage', user.access_level === 0) && (
      <Grid>
        <Grid
          sx={{
            backgroundColor: 'background.default', p: 1
          }}
        >
          <CampaignTime
            timeToPass={donnees.timeToPass !== undefined ? donnees.timeToPass.time : ''}
            averageTime={donnees.timeToPass !== undefined && donnees.totalTreatedReinjOrNotCustomers !== undefined ? donnees.totalTreatedReinjOrNotCustomers.number !== 0 ? donnees.timeToPass.time / donnees.totalTreatedReinjOrNotCustomers.number : donnees.timeToPass.time : ''}
          />
        </Grid>
        <Grid
          sx={{
            backgroundColor: 'background.default',
            p: 1,
          }}
        >
          <CampaignSource
            sourceProfession={donnees.sourceProfession}
            professions={donnees.professions === undefined ? [] : donnees.professions}
          />
        </Grid>
      </Grid>
      )}
      {can('campaign.manage', user.access_level === 0) && (
      <Grid
        sx={{
          backgroundColor: 'background.default',
          p: 1
        }}
      >
        <CampaignTotal
          occupationAndSource={donnees.occupationAndSource === undefined ? [] : donnees.occupationAndSource}
          professions={donnees.professions === undefined ? [] : donnees.professions}
          occupationAndSourceTreated={donnees.occupationAndSourceTreated}
        />
      </Grid>
      )}
      {can('campaign.manage', user.access_level === 0) && (
      <Grid
        sx={{
          backgroundColor: 'background.default',
          p: 1
        }}
      >
        <CampaignStatusList
          statusAndSource={donnees.statusAndSource === undefined ? [] : donnees.statusAndSource}
          qualification={donnees.qualification === undefined ? [] : donnees.qualification}
          commercial={donnees.commercial}
        />
      </Grid>
      )}
    </>
  );
};
CampaignStatsTab.propTypes = {
  setOpenReinjection: PropTypes.func,
  setOpenRetrieve: PropTypes.func,
  setSelectedCommercialReinjection: PropTypes.func,
  setSelectedCommercialRetrieve: PropTypes.func,
  idCampaign: PropTypes.string,
  donnees: PropTypes.object.isRequired,
  progressionProspects: PropTypes.number.isRequired,
};
export default CampaignStatsTab;
